import type { Route } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { TicketSource } from './models/ticket.model';
import { TICKET_SOURCE } from './ticket-source.token';
import {
  TICKET_SIDENAV_PERMISSION,
  TICKET_VIEW_SIDENAV_PERMISSION,
} from './tickets-permission';

export interface TicketRoutesOptions {
  /** Include the admin "Ticketverwaltung" route. Only BackOffice enables this. */
  includeManagement?: boolean;
}

export function ticketRoutes(
  source: TicketSource,
  options: TicketRoutesOptions = {},
): Route[] {
  const routes: Route[] = [
    {
      path: 'my-tickets',
      canActivate: [ngxPermissionsGuard],
      providers: [{ provide: TICKET_SOURCE, useValue: source }],
      data: {
        translate: 'tickets',
        permissions: { only: TICKET_VIEW_SIDENAV_PERMISSION },
      },
      loadComponent: () =>
        import('./my-tickets/my-tickets.component').then(
          (m) => m.MyTicketsComponent,
        ),
      children: [
        {
          path: 'preview/new',
          loadComponent: () =>
            import(
              './my-tickets/ticket-create-dialog/ticket-create-dialog.component'
            ).then((m) => m.TicketCreateDialogComponent),
        },
        {
          path: 'preview/:id',
          loadComponent: () =>
            import(
              './ticket-detail-dialog/ticket-detail-dialog.component'
            ).then((m) => m.TicketDetailDialogComponent),
          data: { admin: false },
        },
      ],
    },
  ];

  if (options.includeManagement) {
    routes.push({
      path: 'tickets',
      canActivate: [ngxPermissionsGuard],
      data: {
        translate: 'tickets',
        permissions: { only: TICKET_SIDENAV_PERMISSION },
      },
      loadComponent: () =>
        import('./tickets-management/tickets-management.component').then(
          (m) => m.TicketsManagementComponent,
        ),
      children: [
        {
          path: 'preview/:id',
          loadComponent: () =>
            import(
              './ticket-detail-dialog/ticket-detail-dialog.component'
            ).then((m) => m.TicketDetailDialogComponent),
          data: { admin: true },
        },
      ],
    });
  }

  return routes;
}
